module.exports = __webpack_public_path__ + "cc665d44cefd7ca1c1bd1826a44fb333.svg";